<!--
  Action dialog "Abrechnung neu ausstellen".

  No hand-written form HTML: the reason field is rendered by the transient form widget
  (<mvs-widget> with an MvsFormDto built in the TS), exactly like
  cp-provision-agent-manual-booking-dialog. Everything else is the dialog frame, the
  statement summary and the action button that calls the custom reissue endpoint.
-->
<p-dialog
        header="Abrechnung neu ausstellen"
        [visible]="visible"
        (visibleChange)="handleVisibleChange($event)"
        (onShow)="handleShow()"
        [modal]="true"
        [draggable]="false"
        [resizable]="false"
        [style]="{width: '40rem'}"
        [breakpoints]="{'960px': '90vw'}">

    @if (!statement) {

        <p-skeleton height="12rem"></p-skeleton>

    } @else {

        <!-- Which statement is replaced -->
        <div class="surface-100 border-round-lg p-3 mb-3">
            <div class="flex flex-wrap align-items-center gap-3">
                <div class="flex flex-column">
                    <span class="text-sm text-color-secondary">Abrechnungsnummer</span>
                    <span class="font-semibold">{{ statement.statementNumber || '—' }}</span>
                </div>
                <div class="flex flex-column">
                    <span class="text-sm text-color-secondary">Version</span>
                    <span class="font-semibold">{{ statement.version ?? '—' }}</span>
                </div>
                @if (statement.provisionRunDtoName) {
                    <div class="flex flex-column">
                        <span class="text-sm text-color-secondary">Provisionslauf</span>
                        <span class="font-semibold">{{ statement.provisionRunDtoName }}</span>
                    </div>
                }
                @if (statement.windowToValutaDate) {
                    <div class="flex flex-column">
                        <span class="text-sm text-color-secondary">Valuta bis</span>
                        <span class="font-semibold">{{ statement.windowToValutaDate | date:'dd.MM.yyyy' }}</span>
                    </div>
                }
            </div>
        </div>

        <p-message severity="info" styleClass="w-full mb-3">
            <span class="text-sm">
                Es wird eine neue Fassung mit neuer Abrechnungsnummer erstellt. Die bisherige Fassung
                wird als „Ersetzt“ markiert und bleibt im Dokumentenarchiv erhalten.
            </span>
        </p-message>

        @if (formWidget) {
            <mvs-widget
                    [widgetData]="formWidget"
                    (onGenericEvent)="handleGenericEvent($event)">
            </mvs-widget>

            <div class="flex justify-content-between align-items-center mt-2 text-sm">
                <span class="text-red-600">{{ validationMessage }}</span>
                <span [ngClass]="reasonTooLong ? 'text-red-600 font-semibold' : 'text-color-secondary'">
                    {{ reasonLength }} / {{ reasonMaxLength }} Zeichen
                </span>
            </div>
        }

        @if (failureMessage) {
            <p-message severity="error" [text]="failureMessage" styleClass="w-full mt-3"></p-message>
        }
    }

    <ng-template pTemplate="footer">
        <p-button
                label="Abbrechen"
                icon="fa-regular fa-xmark"
                severity="secondary"
                [text]="true"
                (onClick)="handleClose()">
        </p-button>

        <p-button
                label="Neu ausstellen"
                icon="fa-regular fa-file-circle-plus"
                severity="primary"
                [loading]="busy"
                [disabled]="!submittable"
                (onClick)="handleReissue()">
        </p-button>
    </ng-template>

</p-dialog>
